<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="~@/common/imgs/honor.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>荣誉资质</h3>
            <p>Honorary Certificate</p>
          </dt>
          <dd class="w33">
            <router-link :to="{path: '/HonorMention',query:{id: '1'}}" :class="this.$route.query.id == '1' ? 'active' : ''"><span>企业资质</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w33">
            <router-link :to="{path: '/HonorMention',query:{id: '2'}}" :class="this.$route.query.id == '2' ? 'active' : ''"><span>企业荣誉</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w33">
            <router-link to="PjHonor" :class="{active: true}"><span>工程荣誉</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>荣誉资质</h2>/<i>工程荣誉</i>
        </div>
        <div class="imgs-list">
          <div class="list-title"><h3>中国建设工程鲁班奖</h3></div>
          <ul>
            <li v-for="item in luban" :key="item.id"><img :src="item.fileVo.url"></li>
          </ul>
          <div class="list-title"><h3>中国建设工程装饰奖</h3></div>
          <ul>
            <li v-for="item in guoyou" :key="item.id"><img :src="item.fileVo.url"></li>
          </ul>
          <div class="list-title"><h3>省优秀建筑装饰工程奖</h3></div>
          <ul>
            <li v-for="item in shengyou" :key="item.id"><img :src="item.fileVo.url"></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>
     <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'PjHonor',
    data() {
      return {
        url: global_msg.baseUrl,
        luban: [],//鲁班奖
        guoyou: [],//国优
        shengyou: [],//省优
      }
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    created() {
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=中国建设工程鲁班奖').then((response) => {
        this.luban = response.data.subject.result[0].attachmentVos;
      });
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=中国建设工程装饰奖').then((response) => {
        this.guoyou = response.data.subject.result[0].attachmentVos;
      });
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=各省优秀建筑装饰工程奖').then((response) => {
        this.shengyou = response.data.subject.result[0].attachmentVos;
      });
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/PjHonor.vue